import { PsType, VStudentsNoNulls } from ".";

export const API_URLBASE = `http${
  process.env.REACT_APP_EXPRESSAPI_HOST?.startsWith("localhost:") ? "" : "s"
}://${process.env.REACT_APP_EXPRESSAPI_HOST}/v2`;

export const COMPONENT_STYLE = { p: 0, height: "100%", minHeight: "calc(100vh - 32px)" };
export const COMPONENT_CUSTOM_MAXHEIGHT = (addlOffset: number) => `calc(100vh - 120px - ${addlOffset}px)`;

export const CRPS_ORANGE_LIGHT = "#cc6600";
export const CRPS_ORANGE_LIGHT_BRIGHT = "#ff6e00";
export const CRPS_ORANGE_DARK = "#a65e00";
export const CRPS_ORANGE_DARK_BRIGHT = "#f37f1b";

export const EXPORT_COLUMNS_SORTED = [
  "Classroom",
  "Intensity",
  "Grade",
  "Last Name",
  "First Name",
  "ID #",
  "Gender",
  "Indigenous",
  "Achievement",
  "Behaviour",
  "Social",
  "ELL",
  "SpEd1",
  "SpEd2",
  "SpEd3",
  "SpClEd1",
  "SpClEd2",
];

export const EXPORT_COLUMNS_STUDENTS = [
  "Grade",
  "Last Name",
  "First Name",
  "ID #",
  "Gender",
  "Indigenous",
  "Achievement",
  "Behaviour",
  "Social",
  "ELL",
  "SpEd1",
  "SpEd2",
  "SpEd3",
  "SpClEd1",
  "SpClEd2",
];

export const PG_ERR_MSG = "Please contact your administrator to get permission to use PowerSorter";

export const psLocalStorageCond = "conditionsSel";
export const psLocalStorageFilter = (type: PsType) => `filter${type}`;
export const psLocalStorageSorted = "sortedSel";
export const psLocalStorageSortedTotals = "sortedTotals";

export const PWREQ_LENGTH = 8;
export const PWREQ_NUM_DIGIT = 1;
export const PWREQ_NUM_LOWER = 3;
export const PWREQ_NUM_SPECIAL = 1;
export const PWREQ_NUM_UPPER = 1;

export const SNACKBAR_HIDE_MS = 5000;

export const STUDENT_ELLS = [0, 6, 5, 4, 3, 2, 1];
export const STUDENT_GENDERS = ["", "F", "M", "X"];
export const STUDENT_INTENSITY_THRESHOLD_HIGH = 200;
export const STUDENT_INTENSITY_THRESHOLD_VERYHIGH = 400;

export const TEACHER_PREFIXES = ["N/A", "Dr.", "Miss", "Mr.", "Mrs.", "Ms.", "Mx."];

export const UPLOAD_COLUMNS_CLASSROOMS = ["Name", "Teacher Prefix", "Teacher First", "Teacher Last"];
export const UPLOAD_COLUMNS_PSCHOOL_STUDENTS = [
  "First_Name",
  "Last_Name",
  "S_AB_STU_X.FNMI",
  "Sched_NextYearGrade",
  "State_StudentNumber",
  "U_StudentsUserFields.cc_ell_level_current",
  "U_StudentsUserFields.cc_spd_excep_cd_1_detail",
  "U_StudentsUserFields.cc_spd_excep_cd_2_detail",
  "U_StudentsUserFields.cc_spd_excep_cd_3_detail",
  // "AB_spcl_Edu_stu_1",
  // "AB_spcl_Edu_stu_2",
];
export const UPLOAD_COLUMNS_STUDENTS = [
  "Grade",
  "Last Name",
  "First Name",
  "ID #",
  "Gender",
  "Indigenous",
  "Achievement",
  "Behaviour",
  "Social",
  "ELL",
  "SpEd1",
  "SpEd2",
  "SpEd3",
  "SpClEd1",
  "SpClEd2",
];
export const UPLOAD_COLUMNS_TEACHERS = ["Prefix", "First", "Last", "Years"];

/**
 * todo: module
 */
export const CONDITION_CONFLICTS = [
  { id: 0, desc: "Teacher Not Assigned To Classroom" },
  { id: 1, desc: "Classrooms Of Grade Full" },
  { id: 2, desc: "Grade Has No Classroom" },
  { id: 3, desc: "Pairing Fail" },
  { id: 4, desc: "Separation Fail" },
  { id: 5, desc: "Delta Reached" },
];
export const conditionConflictsDescToIdMap = new Map(CONDITION_CONFLICTS.map(({ id, desc }) => [desc, id]));

// even: pairing, odd: separation
export const CONDITION_DEFINITIONS = [
  { id: 0, desc: "Wish" },
  { id: 1, desc: "Wish Not" },
  { id: 2, desc: "Should" },
  { id: 3, desc: "Should Not" },
  { id: 4, desc: "Must" },
  { id: 5, desc: "Must Not" },
];
export const conditionDefinitionsDescToIdMap = new Map(CONDITION_DEFINITIONS.map(({ id, desc }) => [desc, id]));

export const CONDITION_OWNERS = [
  { id: 0, desc: "SYSTEM" },
  { id: 1, desc: "Student" },
  { id: 2, desc: "Parent" },
  { id: 3, desc: "Teacher" },
  { id: 4, desc: "Principal" },
  { id: 5, desc: "Legal" },
];
export const conditionOwnersDescToIdMap = new Map(CONDITION_OWNERS.map(({ id, desc }) => [desc, id]));

export const GRADES = [
  "ECS-AM",
  "ECS-PM",
  "Gr 1",
  "Gr 2",
  "Gr 3",
  "Gr 4",
  "Gr 5",
  "Gr 6",
  "Gr 7",
  "Gr 8",
  "Gr 9",
  "Gr 10",
  "Gr 11",
  "Gr 12",
  "Gr 13",
];
export type Grade = (typeof GRADES)[number];

const SORT_WEIGHT_AI = 100;
const SORT_WEIGHT_BI = 1;
const SORT_WEIGHT_RI = 1;
const SORT_WEIGHT_RI_ELL = 200;
const SORT_WEIGHT_RI_SPED = 0.5;
const SORT_WEIGHT_SI = 100;

export const intensities = (student: VStudentsNoNulls) => ({
  achievement: student.sa_id,
  behaviour: student.sb_id,
  resource:
    (student.indigenous === true ? 2 : 0) +
    student.ell +
    (student.sp_ed_1 >= 60 ? 1 : student.sp_ed_1 >= 50 ? 2 : student.sp_ed_1 >= 40 ? 3 : 0) +
    (student.sp_ed_2 >= 60 ? 1 : student.sp_ed_2 >= 50 ? 2 : student.sp_ed_2 >= 40 ? 3 : 0) +
    (student.sp_ed_3 >= 60 ? 1 : student.sp_ed_3 >= 50 ? 2 : student.sp_ed_3 >= 40 ? 3 : 0) +
    (student.spcl_ed_1 >= 60 ? 1 : student.sp_ed_3 >= 50 ? 2 : student.spcl_ed_1 >= 40 ? 3 : 0) +
    (student.spcl_ed_2 >= 60 ? 1 : student.sp_ed_3 >= 50 ? 2 : student.spcl_ed_2 >= 40 ? 3 : 0),
  social: student.ss_id,
});
// export const intensities = (student: VStudentsNoNulls) => ({
//   achievement: Math.round(SORT_WEIGHT_AI * (Math.abs(student.sa_id) + 1)),
//   behaviour: Math.round(SORT_WEIGHT_BI * (Math.abs(student.sb_id) + 1)),
//   resource: Math.round(
//     SORT_WEIGHT_RI *
//       (SORT_WEIGHT_RI_ELL * (!student.ell || student.ell === 0 ? 0 : 1 / student.ell) +
//         SORT_WEIGHT_RI_SPED *
//           ((student.sp_ed_1 ?? 0) +
//             (student.sp_ed_2 ?? 0) +
//             (student.sp_ed_3 ?? 0) +
//             (student.spcl_ed_1 ?? 0) +
//             (student.spcl_ed_2 ?? 0))),
//   ),
//   social: Math.round(SORT_WEIGHT_SI * (Math.abs(student.ss_id) + 1)),
// });

// enum SortMetric {
//   "Gender",
//   "Resource",
//   "Social",
//   "Achievement",
// }

export const STUDENT_ACHIEVEMENTS = [
  { id: 0, desc: "None" },
  { id: 3, desc: "High" },
  { id: 2, desc: "Medium" },
  { id: 1, desc: "Low" },
];
export const studentAchievementsDescToIdMap = new Map(STUDENT_ACHIEVEMENTS.map(({ id, desc }) => [desc, id]));

export const STUDENT_BEHAVIOURS = [
  { id: 0, desc: "None" },
  { id: 1, desc: "Difficult" },
  { id: 2, desc: "Very Difficult" },
];
export const studentBehavioursDescToIdMap = new Map(STUDENT_BEHAVIOURS.map(({ id, desc }) => [desc, id]));

export const STUDENT_SOCIALS = [
  { id: 2, desc: "Very Extroverted" },
  { id: 1, desc: "Extroverted" },
  { id: 0, desc: "None" },
  { id: -1, desc: "Introverted" },
  { id: -2, desc: "Very Introverted" },
];
export const studentSocialsDescToIdMap = new Map(STUDENT_SOCIALS.map(({ id, desc }) => [desc, id]));

export enum SortMetric {
  Resource,
  Social,
  Achievement,
  Behaviour,
  Gender,
}

type BlockedMetricInfo = {
  metric: SortMetric;
  wouldBeGap: number;
  baseline: number;
  allowedMax: number; // baseline + regressionTolerance
  extraRegressionNeeded: number; // how much to raise regressionTolerance to unlock this swap
};

type MetricBalanceReport = {
  metric: SortMetric;
  finalGap: number;
  tolerance: number;
  stopReason: "converged" | "single-room" | "no-improving-swap" | "blocked-by-regression";
  blockedDetail?: BlockedMetricInfo[]; // present only when stopReason === "blocked-by-regression"
};

export type ClassroomIntensities = { roomName: string; grades: { [gr: string]: { [metric: string]: number } } };

export type GradeIntensities = { grade: string; intensities: { [metric: string]: MetricBalanceReport } };
